import { Pipe, PipeTransform } from '@angular/core';
import { MonthlyLunchMenuChoices } from './meal-service.model';

@Pipe({
  name: 'monthlyLunchMenuFilter'
})
export class MonthlyLunchMenuFilterPipe implements PipeTransform {

  transform(monthlyLunchMenuChoices: MonthlyLunchMenuChoices[], column: MonthlyLunchMenuChoices): MonthlyLunchMenuChoices[] {
    return monthlyLunchMenuChoices.filter(
      obj => (obj.Choice === column.Choice)
    );
  }
}
